import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-widgets-lists-18',
  templateUrl: './18.component.html',
  styleUrls: ['./18.component.scss'],
})
export class VbList18Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
